import { platformGuard } from '@/router/guards'
import { RouteName } from '@/base/constants/route'

const authRoutes = {
  path: '/auth',
  name: RouteName.AUTH,
  meta: {
    title: 'Auth',
  },
  redirect: { name: RouteName.AUTH_LOGIN },
  beforeEnter: [platformGuard],
  children: [
    {
      path: '',
      name: RouteName.AUTH_LOGIN_LAYOUT,
      meta: {
        title: 'Auth Login Layout',
      },
      component: () => import('@/pages/main/layout/Auth.vue'),
      children: [
        {
          path: 'login',
          name: RouteName.AUTH_LOGIN,
          meta: {
            title: 'Login',
            analyticsPageName: 'Login',
            disableAuthCheck: true,
          },
          alias: ['/login', '/auth/login/searchads'],
          component: () => import('@/pages/auth/Login.vue'),
        },
        {
          path: 'login-sso',
          name: RouteName.AUTH_LOGIN_SSO,
          meta: {
            title: 'Login SSO',
            analyticsPageName: 'Login SSO',
            disableAuthCheck: true,
          },
          alias: ['/login-sso', '/auth/login-sso/searchads'],
          component: () => import('@/pages/auth/LoginSSO.vue'),
        },
        {
          path: 'logout',
          name: RouteName.AUTH_LOGOUT,
          meta: {
            title: 'Logout',
            analyticsPageName: 'Logout',
            disableAuthCheck: true,
          },
          alias: ['/logout', '/auth/logout/searchads'],
          component: () => import('@/pages/auth/Logout.vue'),
        },
        {
          path: 'recover',
          name: RouteName.AUTH_RECOVER,
          meta: {
            title: 'Recover',
            analyticsPageName: 'Recover',
            disableAuthCheck: true,
          },
          alias: ['/recover', '/auth/recover/searchads'],
          component: () => import('@/pages/auth/Recover.vue'),
        },
        {
          path: 'recover-reset',
          name: RouteName.AUTH_RECOVER_RESET,
          meta: {
            title: 'Recover Reset',
            analyticsPageName: 'Recover Reset',
            disableAuthCheck: true,
          },
          alias: ['/recover/reset', '/auth/recover-reset/searchads'],
          component: () => import('@/pages/auth/RecoverReset.vue'),
        },
        {
          path: ':type(google|apple|linkedin|sso)/callback',
          name: RouteName.AUTH_CALLBACK,
          meta: {
            title: 'Auth Callback',
            analyticsPageName: 'Auth Callback',
            disableAuthCheck: true,
          },
          alias: ['/auth/:type(google|apple|linkedin|sso)/callback/searchads'],
          component: () => import('@/pages/auth/Callback.vue'),
        },
        {
          path: 'invite-complete',
          name: RouteName.AUTH_INVITE_COMPLETE,
          meta: {
            title: 'Complete Invitation',
            analyticsPageName: 'Complete Invitation',
            disableAuthCheck: true,
          },
          alias: ['/invite/complete', '/auth/invite-complete/searchads'],
          component: () => import('@/pages/auth/InviteComplete.vue'),
        },
        {
          path: 'delete-account',
          name: RouteName.AUTH_DELETE_ACCOUNT,
          meta: {
            title: 'Delete Account',
            disableAuthCheck: true,
          },
          alias: ['/delete-account'],
          component: () => import('@/pages/auth/DeleteAccount.vue'),
        },
      ],
    },
    {
      path: '',
      name: RouteName.AUTH__REGISTER_LAYOUT,
      meta: {
        title: 'Auth Register Layout',
      },
      component: () => import('@/pages/main/layout/OnlyContent.vue'),
      children: [
        {
          path: 'register',
          name: RouteName.AUTH_REGISTER,
          meta: {
            title: 'Register',
            analyticsPageName: 'Register',
            disableAuthCheck: true,
          },
          alias: ['/register', '/auth/register/searchads'],
          component: () => import('@/pages/auth/Register.vue'),
        },
        {
          path: 'register-verify',
          name: RouteName.AUTH_REGISTER_VERIFY,
          meta: {
            title: 'Register Verify',
            analyticsPageName: 'Register Verify',
            disableAuthCheck: true,
          },
          alias: ['/register/verify', '/auth/register-verify/searchads'],
          component: () => import('@/pages/auth/RegisterVerify.vue'),
        },
        {
          path: 'register-success',
          name: RouteName.AUTH_REGISTER_SUCCESS,
          meta: {
            title: 'Register Success',
            analyticsPageName: 'Register Success',
            disableAuthCheck: true,
          },
          alias: ['/register/success', '/auth/register-success/searchads'],
          component: () => import('@/pages/auth/RegisterSuccess.vue'),
        },
      ],
    },
  ],
}

export default authRoutes
